import React, { useState, useEffect, useRef } from 'react';
import { ChevronDown } from 'lucide-react';
import { useTheme } from '../ThemeContext';

const DeliverySelect = ({ value, onChange, deliveries }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState('');
    const dropdownRef = useRef(null);
    const { isDark } = useTheme();

    // Ferme le dropdown si on clique en dehors
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Filtre les deliveries selon la recherche
    const filteredDeliveries = deliveries.filter(delivery =>
        delivery.Name.toLowerCase().includes(search.toLowerCase())
    );

    // Trouve le nom du delivery sélectionné
    const selectedDelivery = deliveries.find(d => d.Id === value);

    return (
        <div className="relative" ref={dropdownRef}>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Delivery
            </label>

            {/* Bouton qui affiche la sélection actuelle */}
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className="w-full px-4 py-3 rounded-xl border focus:ring-2 focus:ring-blue-400 focus:border-transparent outline-none text-left bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white flex justify-between items-center"
            >
                <span className="truncate">
                    {selectedDelivery ? selectedDelivery.Name : 'Sélectionnez un delivery'}
                </span>
                <ChevronDown
                    className={`w-5 h-5 text-gray-400 dark:text-gray-500 transition-transform ${isOpen ? 'transform rotate-180' : ''}`}
                />
            </button>

            {/* Dropdown */}
            {isOpen && (
                <div className="absolute z-50 w-full mt-1 bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 max-h-[300px] flex flex-col">
                    {/* Barre de recherche - reste fixe en haut */}
                    <div className="p-2 border-b border-gray-200/20 dark:border-gray-700/20 bg-white dark:bg-gray-800 sticky top-0">
                        <input
                            type="text"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Rechercher..."
                            className="w-full px-3 py-2 rounded-lg border text-sm focus:ring-2 focus:ring-blue-400 focus:border-transparent outline-none dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                            autoFocus
                        />
                    </div>

                    {/* Liste scrollable des deliveries */}
                    <div className="overflow-y-auto flex-1">
                        <div className="pb-2">  {/* Ajout d'un conteneur avec padding bottom */}
                            {filteredDeliveries.map((delivery) => (
                                <button
                                    key={delivery.Id}
                                    onClick={() => {
                                        onChange({ target: { name: 'delivery', value: delivery.Id } });
                                        setIsOpen(false);
                                        setSearch('');
                                    }}
                                    className={`w-full px-4 py-2 text-left hover:bg-blue-50 dark:hover:bg-blue-400/10 transition-colors ${value === delivery.Id
                                        ? 'bg-blue-50 dark:bg-blue-400/20 text-blue-600 dark:text-blue-400'
                                        : 'dark:text-white'
                                        }`}
                                >
                                    {delivery.Name}
                                </button>
                            ))}
                            {filteredDeliveries.length === 0 && (
                                <div className="px-4 py-2 text-gray-500 dark:text-gray-400 text-center">
                                    Aucun résultat
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DeliverySelect;